export const sum = (field, entries) => {
  const vals = entries
    .map(entry => entry[field] != null ? parseFloat(entry[field]) : null)
    .filter(value => value !== null && !isNaN(value));
  return vals.length > 0 ? vals.reduce((a, b) => a + b, 0) : null;
};

export const avg = (field, entries) => {
  const vals = entries
    .map(entry => entry[field] != null ? parseFloat(entry[field]) : null)
    .filter(value => value !== null && !isNaN(value));
  return vals.length > 0 ? vals.reduce((a, b) => a + b, 0) / vals.length : null;
};

export const sumOrNull = (arr) => arr.some(v => v != null) ? arr.reduce((s, v) => s + (v || 0), 0) : null;